function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "vue-01",
  transform: "translate(-1.000000, -2.000000)",
  fillRule: "nonzero",
  fill: "url(#tech-gradient) #000"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(132.683800, 115.345000) scale(-1, 1) rotate(-180.000000) translate(-132.683800, -115.345000) translate(0.687100, 0.681200)"
}, React.createElement("g", {
  transform: "translate(0.079998, 0.013333)",
  id: "Shape",
  opacity: 0.5
}, React.createElement("polygon", {
  points: "161.3293 227.9943 131.104722 175.643609 100.880145 227.9943 0.2279943 227.9943 131.104722 1.306634 261.98145 227.9943"
})), React.createElement("g", {
  transform: "translate(52.078698, 90.677733)",
  id: "Shape"
}, React.createElement("polygon", {
  points: "109.3306 137.3299 79.1060223 84.9792088 48.8814446 137.3299 0.5799855 137.3299 79.1060223 1.319967 157.632059 137.3299"
})))));

function SvgVue01(props) {
  return React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "262px",
    height: "227px",
    viewBox: "0 0 262 227"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQgbWVldCIgd2lkdGg9IjI2MnB4IiBoZWlnaHQ9IjIyN3B4IiB2aWV3Qm94PSIwIDAgMjYyIDIyNyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJ2dWUtMDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjAwMDAwMCwgLTIuMDAwMDAwKSIgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJ1cmwoI3RlY2gtZ3JhZGllbnQpICMwMDAiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMi42ODM4MDAsIDExNS4zNDUwMDApIHNjYWxlKC0xLCAxKSByb3RhdGUoLTE4MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTMyLjY4MzgwMCwgLTExNS4zNDUwMDApIHRyYW5zbGF0ZSgwLjY4NzEwMCwgMC42ODEyMDApIj4KICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDc5OTk4LCAwLjAxMzMzMykiIGlkPSJTaGFwZSIgb3BhY2l0eT0iMC41Ij4KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBwb2ludHM9IjE2MS4zMjkzIDIyNy45OTQzIDEzMS4xMDQ3MjIgMTc1LjY0MzYwOSAxMDAuODgwMTQ1IDIyNy45OTQzIDAuMjI3OTk0MyAyMjcuOTk0MyAxMzEuMTA0NzIyIDEuMzA2NjM0IDI2MS45ODE0NSAyMjcuOTk0MyI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTIuMDc4Njk4LCA5MC42Nzc3MzMpIiBpZD0iU2hhcGUiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIHBvaW50cz0iMTA5LjMzMDYgMTM3LjMyOTkgNzkuMTA2MDIyMyA4NC45NzkyMDg4IDQ4Ljg4MTQ0NDYgMTM3LjMyOTkgMC41Nzk5ODU1IDEzNy4zMjk5IDc5LjEwNjAyMjMgMS4zMTk5NjcgMTU3LjYzMjA1OSAxMzcuMzI5OSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgVue01 as ReactComponent };